import "./App.css";
import { Suspense } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { PreLoginRoutes } from "./routes/preLoginRoutes";
import { PostLoginRoutes } from "./routes/postLoginRoutes";
import Loader from "./components/Loader";
import ProtectedRoutes from "./utils/validations/protectedRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  return (
    <Router>
      <ToastContainer />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />

          {PreLoginRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
          {PostLoginRoutes.map((route) => (
            <Route
              key={route.id}
              path={route.path}
              element={
                <ProtectedRoutes>
                  <route.element />
                </ProtectedRoutes>
              }
            />
          ))}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
